import React from 'react';
import { BackButton, Container, Wrapper } from './styles';
import { FaArrowLeft } from 'react-icons/fa6';

interface ITitle {
  label: string;
  weight?: string;
  margin?: string;
  line?: string;
}

export const ActionTitle: React.FC<ITitle> = (props) => {
  const { label, weight, margin, line } = { ...props };
  return (
    <Wrapper margin={margin}>
      <BackButton type="button">
        <FaArrowLeft />
      </BackButton>
      <Container weight={weight} line={line}>
        {label}
      </Container>
    </Wrapper>
  );
};
